import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import Login from './pages/system/Login';
import MainLayout from './components/Layout/MainLayout';
import ProtectedRoute from './components/Layout/ProtectedRoute';
import Forbidden from './pages/system/Forbidden';
import { routeConfig, RouteConfigItem } from './config/routes';
import OrderReport from './pages/order/OrderReport';
import './App.css';

const App: React.FC = () => {
  const getFirstRoutePath = (routes: RouteConfigItem[]): string => {
    for (const route of routes) {
      if (route.hideInMenu) continue;
      if (route.component) return route.key;
      if (route.children && route.children.length > 0) {
        const childPath = getFirstRoutePath(route.children);
        if (childPath) return childPath;
      }
    }
    return '/welcome'; // Default fallback
  };

  const defaultRoute = getFirstRoutePath(routeConfig);

  const renderRoutes = (routes: RouteConfigItem[]) => {
    return routes.map((route) => {
      const currentRoute = route.component ? (
        <Route
          key={route.key}
          path={route.key}
          element={
            <ProtectedRoute requiredPermissions={route.permission}>
              <route.component />
            </ProtectedRoute>
          }
        />
      ) : null;

      const childRoutes = route.children ? renderRoutes(route.children) : null;

      return (
        <React.Fragment key={`fragment-${route.key}`}>
          {currentRoute}
          {childRoutes}
        </React.Fragment>
      );
    });
  };

  return (
    <ConfigProvider locale={zhCN}>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/403" element={<Forbidden />} />
          <Route 
            path="/order/report/:orderNo" 
            element={
              <ProtectedRoute>
                <OrderReport />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/" 
            element={
              <ProtectedRoute>
                <MainLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Navigate to={defaultRoute} replace />} />
            {renderRoutes(routeConfig)}
          </Route>
          <Route path="*" element={<Navigate to="/403" replace />} />
        </Routes>
      </Router>
    </ConfigProvider>
  );
};

export default App;
